import { useIsMutating } from 'react-query';

import { orderIntentMutationFilter, purchaseOrderMutationFilter } from '..';

export const useIsMutatingOrder = () => {
  const isMutatingOrderIntent = useIsMutating(orderIntentMutationFilter) > 0;
  const isMutatingPurchaseOrder =
    useIsMutating(purchaseOrderMutationFilter) > 0;

  const isMutating = isMutatingPurchaseOrder || isMutatingOrderIntent;

  return { isMutating };
};
